import { forwardRef, useImperativeHandle } from 'react';

import { ButtonType } from '@xemplo/button';
import { DawnTriangleAlert } from '@xemplo/icons';
import { Prompt, PromptDialogSlot, usePromptDialog } from '@xemplo/prompt-dialog';
import { Colour } from '@xemplo/style-constants';

import {
  CreatePayrunApprovalDialogProps,
  CreatePayrunApprovalDialogRef,
} from './create-payrun-approvers-form.types';

export const CancelPrompt = forwardRef<
  CreatePayrunApprovalDialogRef,
  CreatePayrunApprovalDialogProps
>((props: Readonly<CreatePayrunApprovalDialogProps>, ref) => {
  const promptDialog = usePromptDialog({
    id: 'cancel-create-prompt',
  });

  const { confirmCallback } = props;

  useImperativeHandle(ref, () => promptDialog, [promptDialog]);

  const handlePromptConfirm = () => {
    promptDialog.closeDialog();
    confirmCallback?.();
  };

  const handlePromptCancel = () => {
    promptDialog.closeDialog();
  };

  return (
    <Prompt.Dialog {...promptDialog.dialogProps}>
      {promptDialog.isOpen ? (
        <Prompt {...promptDialog.promptProps}>
          <Prompt.Slot
            name={PromptDialogSlot.Header}
            render={
              <Prompt.Header
                title="Are you sure you want to cancel?"
                icon={<DawnTriangleAlert color={Colour.Red[500]} />}
              />
            }
          />
          <Prompt.Slot
            name={PromptDialogSlot.Body}
            render={<Prompt.Body>You will lose any unsubmitted data.</Prompt.Body>}
          />
          <Prompt.Slot
            name={PromptDialogSlot.Footer}
            render={
              <Prompt.Footer
                btnPrimary={{
                  label: 'Yes',
                  ariaLabel: 'Yes Btn',
                  onClick: handlePromptConfirm,
                  type: ButtonType.Primary,
                }}
                btnSecondary={{
                  label: 'No',
                  ariaLabel: 'No Btn',
                  type: ButtonType.Secondary,
                  onClick: handlePromptCancel,
                }}
              />
            }
          />
        </Prompt>
      ) : null}
    </Prompt.Dialog>
  );
});
